import state from './state'

// const change = function() {
//     return state.payment - state.total
// }

export default{
    // change,
}